import leaflet from "leaflet";
export var LeafletUtils;
(function (LeafletUtils) {
    function convert_bounds(bounds) {
        return leaflet.latLngBounds([
            [bounds.getTopLeft().y, bounds.getTopLeft().x],
            [bounds.getBottomRight().y, bounds.getBottomRight().x],
        ]);
    }
    LeafletUtils.convert_bounds = convert_bounds;
    function boundsFromRectangle(box) {
        let tl = leaflet.point(box.topleft);
        let br = leaflet.point(box.botright);
        return leaflet.bounds(tl, br);
    }
    LeafletUtils.boundsFromRectangle = boundsFromRectangle;
    function latLongFromVector2(point) {
        return leaflet.latLng(point.y, point.x);
    }
    LeafletUtils.latLongFromVector2 = latLongFromVector2;
    function latLongToVector2(point) {
        return { x: point.lng, y: point.lat };
    }
    LeafletUtils.latLongToVector2 = latLongToVector2;
})(LeafletUtils || (LeafletUtils = {}));
